module.exports = __webpack_public_path__ + "static/BT-mobile-9-35f575de2eb3cb3c1221e49030ab33c9.jpg";